import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Idle } from '@ng-idle/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-auto-logout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auto-logout.component.html',
  styleUrl: './auto-logout.component.scss'
})
export class AutoLogoutComponent {
  countdown: number = 60;

  constructor(private readonly dialogRef: DialogRef,private readonly idle: Idle) {}

  ngOnInit(): void {
    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.countdown = countdown;
    });
  }

  onContinue(): void {
    this.dialogRef.close('continue');
  }

 
}